window.EG_HELP_CENTRE_SEARCH_UI = {
  closeSearchDropdown: function (ctx) {
    var faqSearchInput = ctx.faqSearchInput;
    var faqSearchArea = ctx.faqSearchArea;
    var currentCategory = ctx.currentCategory;
    var faqResultsLabel = ctx.faqResultsLabel;
    var faqResults = ctx.faqResults;
    var faqNoResults = ctx.faqNoResults;
    var faqSearchMeta = ctx.faqSearchMeta;
    var faqContactTrigger = ctx.faqContactTrigger;
    var form = ctx.form;
    var helpPageContent = ctx.helpPageContent;
    var helpBlockLinks = ctx.helpBlockLinks;
    var FAQ_HELPERS = ctx.FAQ_HELPERS;
    var FAQ_LIMIT = ctx.FAQ_LIMIT;
    var DISPLAY_HELPERS = ctx.DISPLAY_HELPERS;

    if (faqSearchInput) {
      faqSearchInput.value = '';
    }

    if (faqSearchArea) {
      faqSearchArea.classList.remove('is-searching');
    }

    if (currentCategory) {
      if (faqResultsLabel) {
         if (currentCategory === 'troubleshooting') {
          faqResultsLabel.classList.add('cf-hidden');
        } else {
          DISPLAY_HELPERS.setFaqResultsLabel(faqResultsLabel, currentCategory);
          faqResultsLabel.classList.remove('cf-hidden');
        }
      }

      if (faqResults) {
        if (currentCategory === 'troubleshooting') {
          faqResults.classList.add('cf-hidden');
        } else {
          faqResults.classList.remove('cf-hidden');
        }
      }

      if (faqContactTrigger && currentCategory !== 'tracking' && currentCategory !== 'troubleshooting') {
        faqContactTrigger.classList.remove('cf-hidden');
      }

      var subgroup = form.querySelector('.cf-subgroup--' + currentCategory);
      form.querySelectorAll('.cf-subgroup').forEach(function (sg) {
        sg.classList.add('cf-hidden');
      });
      if (subgroup) subgroup.classList.remove('cf-hidden');

      DISPLAY_HELPERS.showHelpPagePanel(helpPageContent, currentCategory);
      DISPLAY_HELPERS.setActiveHelpBlock(helpBlockLinks, currentCategory);

      FAQ_HELPERS.applyFaqLimit({
        form: form,
        faqSearchInput: faqSearchInput,
        FAQ_LIMIT: FAQ_LIMIT
      });
      return;
    }

    if (faqResultsLabel) faqResultsLabel.classList.add('cf-hidden');
    if (faqNoResults) faqNoResults.classList.add('cf-hidden');

    if (faqSearchMeta) {
      faqSearchMeta.textContent = '';
      faqSearchMeta.classList.add('cf-hidden');
    }

    if (faqResults) faqResults.classList.add('cf-hidden');
    if (faqContactTrigger) faqContactTrigger.classList.add('cf-hidden');

    form.querySelectorAll('.cf-subgroup').forEach(function (sg) {
      sg.classList.add('cf-hidden');
    });
  }
};